var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseSolid = function SvgPauseSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.286 22.125a2.786 2.786 0 0 1-2.044-.85 2.786 2.786 0 0 1-.85-2.043V4.768c0-.796.284-1.477.85-2.043a2.786 2.786 0 0 1 2.044-.85c.795 0 1.476.283 2.043.85.566.566.85 1.247.85 2.043v14.464c0 .796-.284 1.477-.85 2.043a2.786 2.786 0 0 1-2.043.85Zm-11.572 0a2.786 2.786 0 0 1-2.043-.85 2.786 2.786 0 0 1-.85-2.043V4.768c0-.796.284-1.477.85-2.043a2.786 2.786 0 0 1 2.043-.85c.796 0 1.477.283 2.043.85.567.566.85 1.247.85 2.043v14.464c0 .796-.283 1.477-.85 2.043a2.786 2.786 0 0 1-2.043.85Z",
    fill: "currentcolor"
  })));
};
export default SvgPauseSolid;